import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import IconCircle from "../shared/IconCircle";
import { cardDescSx, cardTitleSx, COLORS, CONTENT_MAX_WIDTH, FONT } from "../shared/styles";
import { CheckCircleIcon } from "./icons";

function LinkEmailSuccessCard({ userTicketEmail, onUnlink, saveLoading }) {
  return (
    <Box
      sx={{
        mt: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "16px",
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        minHeight: "80px",
        p: "16px 24px",
        borderRadius: "8px",
        border: `1px solid ${COLORS.border}`,
        bgcolor: COLORS.white,
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "16px", flex: 1, minWidth: 0 }}>
        <IconCircle bgcolor={COLORS.backgroundLight}>
          <CheckCircleIcon />
        </IconCircle>
        <Box sx={{ minWidth: 0 }}>
          <Typography component="p" sx={cardTitleSx}>
            Email Linked Successfully
          </Typography>
          <Typography component="p" sx={{ ...cardDescSx, mt: "4px", lineHeight: "18px" }}>
            Your email {userTicketEmail} is verified and active
          </Typography>
        </Box>
      </Box>
      <Button
        onClick={onUnlink}
        disabled={saveLoading}
        sx={{
          flexShrink: 0,
          minWidth: "88px",
          height: "24px",
          p: 0,
          borderRadius: "8px",
          border: `1px solid ${COLORS.border}`,
          bgcolor: COLORS.white,
          boxShadow: COLORS.shadow,
          color: COLORS.error,
          fontFamily: FONT.family,
          fontSize: "12px",
          fontWeight: 500,
          lineHeight: "22px",
          textTransform: "none",
          "&:disabled": { opacity: 0.6 },
        }}
      >
        {saveLoading ? <CircularProgress size={14} sx={{ color: COLORS.error }} /> : "Unlink Email"}
      </Button>
    </Box>
  );
}

export default LinkEmailSuccessCard;
